import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import { checkFootAuth, checkFootTitleAuth } from '../dectorator/checkauthdectorator/index.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
import { checkExchange } from '../../controller/util.js';
import { LINE_TYPE } from '../setting.js';
const model = {
    pdi: {
        Type: Array,
        Default: () => ([])
    },
    mdi: {
        Type: Array,
        Default: () => ([])
    },
    adx: {
        Type: Array,
        Default: () => ([])
    },
    adxr: {
        Type: Array,
        Default: () => ([])
    },
    params: {
        Type: String,
        Default: 'DMI(14,6)'
    }
}
export default class DMIState extends FootDectorator(BaseContext) {
    constructor({ data, ...rest }) {
        super({ ...rest, data: mergeModelData(model, data) });
    }
    _calcRange() {
        let { pdi, mdi, adx, adxr, params } = this.state.data
        let { maxValue, minValue } = this.calcRange({ data: [pdi, mdi, adx, adxr], targetKey: 'value', isAdditional: true });
        // if (maxValue === minValue) {
        //   if (maxValue === 0) {
        //     maxValue = 1;
        //     minValue = -1;
        //   } else if (maxValue === 100) {
        //     maxValue = 150;
        //     minValue = 50;
        //   }
        // } else {
        //   const ratioVal = maxValue * 0.05;
        //   maxValue += ratioVal;
        //   minValue -= ratioVal;
        // }
        this.maxValue = maxValue;
        this.minValue = minValue;
    }
    _calcAxis() {
        const maxValue = this.maxValue;
        const range = maxValue * 2;
        const {
            height
        } = this.availArea;
        const ratio = height / range;
        const { pdi, mdi, adx, adxr, start, end } = this.state.data
        const curryCalcAxis = curryFun(this.calcAxis, this, {
            targetKey: 'value',
            sourceKey: 'lineY',
            isAdditional: true,
        });
        curryCalcAxis({ data: pdi });
        curryCalcAxis({ data: mdi });
        curryCalcAxis({ data: adx });
        curryCalcAxis({ data: adxr });
    }
    _drawMain() {
        const {
            left,
            width,
            height,
            top,
            bottom,
        } = this.availArea;
        const middleY = top + height / 2;
        const { pdi, mdi, adx, adxr } = this.state.data;
        const { LINE } = LINE_TYPE;
        const { pdi: pdiLine, mdi: mdiLine, adx: adxLine, adxr: adxrLine } = this.option.Dmi
        this._drawLine(LINE, pdi, left, bottom, pdiLine.lineWidth, pdiLine.color)
        this._drawLine(LINE, mdi, left, bottom, mdiLine.lineWidth, mdiLine.color)
        this._drawLine(LINE, adx, left, bottom, adxLine.lineWidth, adxLine.color)
        this._drawLine(LINE, adxr, left, bottom, adxrLine.lineWidth, adxrLine.color)
    }
    // 画主图
    _drawAxisY() {
        const { axisY } = this.option.Dmi;
        const {
            left,
            right,
            top,
            bottom,
            height
        } = this.availArea;
        const ctx = this.context;
        const maxValue=this.maxValue
      const minValue=this.minValue
      // const line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
      let line;
      if(maxValue>0&&minValue<0){
        line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
      }else if(maxValue<0&&minValue<0) {
        line=((Math.abs(minValue)-Math.abs(maxValue))/2+minValue).toFixed(2)
      }else {
        line=((Math.abs(maxValue)-Math.abs(minValue))/2+minValue).toFixed(2)
      }
        ctx.beginPath();
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        ctx.fillStyle = axisY.color;
        ctx.font = axisY.sizeRatio * this.state.baseSize * this.dpr + "px " + axisY.fontFamily;
        ctx.fillText(maxValue.toFixed(2), left, top+20);
        ctx.textBaseline = 'middle';
        ctx.fillText(line, left, top + height / 2);
        ctx.textBaseline = 'bottom';
        ctx.fillText(minValue.toFixed(2), left, bottom);
    }
    _drawTitle() {
        const ctx2 = this.curContext;
        //availArea是画布宽高，是一个对象
        const { top } = this.availArea;
        const { current, sealObj } = this.state.data;
        // this.state是一个对象，,height:高度，baseSize:最基本大小
        const { height, baseSize } = this.state;
        // ratioFixed的值为2
        const { ratioFixed } = sealObj;
        const { space } = this.option.Dmi;
        const { baseLine } = this.option.FootContext.title;
        const baseLineY = top + height * baseLine;
        let { left } = this.availArea;
        // left+=ctx2.measureText(this.maxValue.toFixed(2)).width+10
        const {
            sizeRatio,
            fontFamily,
            axisY,
        } = this.option.Dmi;
        [
            'params',
            'pdi',
            'mdi',
            'adx',
            'adxr',
        ].forEach(val => {
            const data = this.state.data[val];
            if (data == 'DMI(14,6)') {
                let color = this.option.Dmi.params.color
                ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
                ctx2.fillStyle = color;
                ctx2.textAlign = 'left';
                ctx2.textBaseline = 'top';
                ctx2.beginPath();
                const text = data
                const textWidth = ctx2.measureText(text).width;
                ctx2.fillText(text, left, baseLineY);
                left += textWidth+10;

            } else {
                if (Util.isArray(data)) {
                    let color = this.option.Dmi[val].color
                    const item = data[current];
                    ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
                    ctx2.fillStyle = color;
                    ctx2.textAlign = 'left'
                    ctx2.textBaseline = 'top';
                    ctx2.beginPath();
                    if (Util.isDef(item) && Util.isValidNumber(item.value)) {
                        // 吧字符串转换为大写
                        const text = val.toUpperCase() + ':' + item.value.toFixed(ratioFixed);
                        const textWidth = ctx2.measureText(text).width
                        ctx2.fillText(text, left, baseLineY);
                        left += textWidth

                    } else {
                        const text = val.toUpperCase() + ': -';
                        const textWidth = ctx2.measureText(text).width;
                        ctx2.fillText(text, left, baseLineY);
                        left += textWidth;
                    }
                    left += space * this.dpr
                }
            }
        })
    }
}
